<mat-dialog-content class="modal">
  <h3>Nicht in unserem Produktfokus enthalten</h3>
  <p>
    Derzeit bieten wir für Anlagen mit installierter Leistung kleiner 100 kWp unabhängig ihrer
    Erzeugungstechnologie keine Angebote für die Direktvermarktung an.
  </p>

  <p>Wir bedauern diesen Schritt und bedanken uns für Ihr Verständnis.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="modal-button" (click)="closeDialog()">Schließen</button>
</mat-dialog-actions>
